import CryptoJS from 'crypto-js';

// WARNING: Storing a secret key in client-side code is insecure.
// This is for demonstration purposes only.

// The static Initialization Vector (IV).
// This must be a 16-byte (16-character) UTF-8 string for AES.
// Both backend and frontend must use the same IV.
const staticIvUtf8 = "GPgj19+Kowt+g4hp";

/**
 * Encrypts data using AES-256-CBC.
 * @param {object} data The data to encrypt (must be JSON-serializable).
 * @param {string} secretKey The 32-byte secret key.
 * @returns {string} The base64-encoded ciphertext.
 */
export const encryptPayload = (data, secretKey) => {
    // 1. Parse the key and IV
    const parsedKey = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse(staticIvUtf8);

    // 2. Encrypt the data
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), parsedKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    // 3. Return only the ciphertext as a base64 string
    return encrypted.toString();
};

/**
 * Decrypts an AES-256-CBC encrypted payload.
 * @param {string} cipherText The base64-encoded ciphertext.
 * @param {string} secretKey The 32-byte secret key.
 * @returns {object} The decrypted data, parsed from JSON.
 */
export const decryptPayload = (cipherText, secretKey) => {
    // 1. Parse the key and IV
    const parsedKey = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse(staticIvUtf8);

    // 2. Decrypt the data
    const decrypted = CryptoJS.AES.decrypt(cipherText, parsedKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    // 3. Convert the decrypted data from UTF-8 and parse from JSON
    const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
};